/** Plain `d` on /main. Alt+D stays the Documents-page shortcut. */
function isDocumentViewerHotkey(event) {
  if (!event || event.altKey || event.ctrlKey || event.metaKey) return false;
  if (event.isComposing) return false;
  if (event.key !== 'd' && event.key !== 'D') return false;
  return !isTypingTarget(event.target);
}

function isTypingTarget(element) {
  if (!element || !element.tagName) return false;
  const tag = String(element.tagName).toUpperCase();
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (element.isContentEditable === true) return true;
  return element.contentEditable === 'true';
}

module.exports = {
  isDocumentViewerHotkey,
  isTypingTarget,
};
